import React from 'react';
import * as ExcelJS from 'exceljs';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

const ExportToExcelParticipantes = ({ data }) => {
  const handleExport = () => {
    const fileExtension = '.xlsx';
    const fileName = 'Participantes_UTF_COL_160' + fileExtension;

    // Crear un nuevo libro de trabajo
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Participantes');
    // Encabezado de múltiples niveles

    // Función auxiliar para convertir columna a número
    const columnToNumber = (column) => {
      let result = 0;
      for (let i = 0; i < column.length; i++) {
        result *= 26;
        result += column.charCodeAt(i) - 'A'.charCodeAt(0) + 1;
      }
      return result;
    };

    // Función auxiliar para convertir número a columna
    const numberToColumn = (number) => {
      let result = '';
      while (number > 0) {
        let remainder = (number - 1) % 26;
        result = String.fromCharCode(65 + remainder) + result;
        number = Math.floor((number - 1) / 26);
      }
      return result;
    };

    // Define la función de formato de fecha
    const formatDate = (dateString) => {
      if (!dateString) return '';

      const date = new Date(dateString);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses son 0-indexados
      const day = String(date.getDate()).padStart(2, '0'); // Asegura que el día tenga dos dígitos

      return `${day}/${month}/${year}`;
    }

    // Función para aplicar color de fondo a un rango de celdas
    const applyBackgroundColor = (startCol, endCol, rowNum, color) => {
      const startColNum = columnToNumber(startCol);
      const endColNum = columnToNumber(endCol);

      for (let colNum = startColNum; colNum <= endColNum; colNum++) {
        const currentCol = numberToColumn(colNum);
        const cellRef = `${currentCol}${rowNum}`;
        worksheet.getCell(cellRef).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color }
        };
      }
    };

    // Encabezado titulo
    worksheet.mergeCells('A1:CN1'); // Titulo
    worksheet.getCell('A1').value = 'LISTA DE PARTICIPANTES';


    // Ajustar el formato específico para la fila 1
    var row1 = worksheet.getRow(1);
    row1.eachCell({ includeEmpty: true }, function (cell, colNumber) {
      cell.font = { size: 16, bold: true }; // Aplicar negrita y tamaño de fuente 16
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "5b9bd5" }, // Color de fondo
      };
    });



    // Encabezado de múltiples niveles
    worksheet.mergeCells('A2:I2');  // Ubicación del proyecto
    worksheet.mergeCells('J2:R2');  // Datos básicos
    worksheet.mergeCells('S2:W2');  // Estado del participante (+2 columnas)
    worksheet.mergeCells('X2:AJ2'); // Población (corrida +2)
    worksheet.mergeCells('AK2:AR2'); // Información familiar (corrida +2)
    worksheet.mergeCells('AS2:BH2'); // Información del proyecto vinculado (corrida +2)
    worksheet.mergeCells('BI2:BK2'); // Datos del beneficiario (corrida +2)
    worksheet.mergeCells('BL2:BM2'); // Conectividad (corrida +2)
    worksheet.mergeCells('BN2:BU2'); // Información bancaria (corrida +2)
    worksheet.mergeCells('BV2:BY2'); // Información organizacional (corrida +2)
    worksheet.mergeCells('BZ2:CE2'); // Validación interna (corrida +2)
    worksheet.mergeCells('CF2:CF2'); // Visitas (corrida +2)

    // Títulos
    worksheet.getCell('A2').value = 'UBICACIÓN DEL PROYECTO';
    worksheet.getCell('J2').value = 'DATOS BÁSICOS';
    worksheet.getCell('S2').value = 'ESTADO DEL PARTICIPANTE';
    worksheet.getCell('X2').value = 'POBLACIÓN';
    worksheet.getCell('AK2').value = 'INFORMACIÓN FAMILIAR';
    worksheet.getCell('AS2').value = 'INFORMACIÓN DEL PROYECTO VINCULADO';
    worksheet.getCell('BI2').value = 'DATOS DEL BENEFICIARIO';
    worksheet.getCell('BL2').value = 'CONECTIVIDAD';
    worksheet.getCell('BN2').value = 'INFORMACIÓN BANCARIA';
    worksheet.getCell('BV2').value = 'INFORMACIÓN ORGANIZACIONAL';
    worksheet.getCell('BZ2').value = 'VALIDACIÓN INTERNA';
    worksheet.getCell('CF2').value = 'VISITAS';

    worksheet.getCell('A2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '0D1B2A' }
    };

    worksheet.getCell('J2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '1B4332' }
    };

    worksheet.getCell('S2').fill = { // Estado del participante
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '581845' }
    };

    worksheet.getCell('X2').fill = { // Población
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '2E2E2E' }
    };

    worksheet.getCell('AK2').fill = { // Información familiar
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '003049' }
    };

    worksheet.getCell('AS2').fill = { // Información del proyecto vinculado
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '014421' }
    };

    worksheet.getCell('BI2').fill = { // Datos del beneficiario
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '2E003E' }
    };

    worksheet.getCell('BL2').fill = { // Conectividad
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '3E2723' }
    };

    worksheet.getCell('BN2').fill = { // Información bancaria
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '191970' }
    };

    worksheet.getCell('BV2').fill = { // Información organizacional
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '4B5320' }
    };

    worksheet.getCell('BZ2').fill = { // Validación interna
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '1A1A2E' }
    };

    worksheet.getCell('CF2').fill = { // Visitas
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '0D1B2A' }
    };

    // Ajustar el formato específico para la fila 2
    var row2 = worksheet.getRow(2);
    row2.eachCell({ includeEmpty: true }, function (cell, colNumber) {
      cell.font = {
        size: 14,
        bold: true,
        color: { argb: 'FFFFFFFF' }  // Añadimos esta línea para hacer el texto blanco
      };
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
    });

    const ecaKeys = data.find(p => p.ecas_info)?.ecas_info
      ? Object.keys(data.find(p => p.ecas_info).ecas_info).filter(
        k => !['total_ecas', 'total_ecas_participa', 'porcentaje_participacion'].includes(k)
      )
      : [];


    const datos =
      [//Ubicación del proyecto
        'N°',
        'Codigo proyecto',
        'Nombre proyecto',
        'Subregión PDET',
        'Departamento',
        'Municipio',
        'Tipo de zona',
        'Nombre de zona',
        'Quien ejecuta',
        //Datos basicos
        'Nombre completo',
        'Tipo de Identificación',
        'Número de Identificación',
        'Sexo',
        'Fecha de Nacimiento',
        '¿Sabe leer y escribir?',
        'Ingresos Mensuales (pesos m/cte)',
        'Línea Económica Principal',
        'Nivel de Escolaridad',
        //'Implementador',
        //Estado del participante
        'Estado dentro del proyecto',
        'Razon del retiro',
        '¿Reemplazo?',
        'Reemplaza a',
        'Soporte retiro',
        //Poblacion
        'Campesino',
        'Comunidad Indígena	',
        'Comunidad NARP',
        'Comunidad ROM',
        'Victima',
        'Discapacidad',
        'LGBT_plus',
        'Mujer rural',
        'Joven rural',
        'Adulto mayor',
        'Reincorporado',
        'Otro',
        //Informacion familiar
        'Cabeza de Familia',
        'Número de Personas a Cargo',
        'Total Núcleo Familiar',
        'Estado Civil',
        'Nombre del Cónyuge',
        'Tipo de Identificación Cónyuge',
        'Identificación Cónyuge',
        'Número de Contacto Cónyuge',
        //Informacion del proyecto vinculado
        'Código shape veredas ART',
        'Nombre del Predio/Finca',
        'Relación de Tenencia con el Predio',
        'Latitud',
        'Longitud',
        'No. Hectáreas Destinadas al Proyecto',
        'Linea productiva 1',
        'Variedad establecida',
        'Linea productiva 2',
        'Número de Hectáreas',
        'Producción anual',
        'Distancia Lugar del Proyecto a Cabecera Municipal - (Kilómetros)',
        'Tiempo Lugar del Proyecto a Cabecera Municipal - (Minutos)',
        'Medio de Transporte',
        '¿Vive en el mismo lugar del Proyecto?',
        '¿Lugar de Vivienda?',
        //Datos del beneficiario
        'Dirección de Correspondencia',
        'Número Telefónico 1',
        'Número Telefónico 2',
        'Correo eléctronico',
        //Conectividad
        'Telefónica',
        'Internet	',
        'Tipo Establecimiento Bancario cercano a su Viviendaónica',
        '¿Cuenta con Productos Financieros?',
        'Cuenta de Ahorro',
        'Tarjeta de Crédito',
        'Otros Créditos',
        'Tipo de entidad',
        //Informacion bancaria
        '¿Ha recibido Capacitación en Educación Financiera?',
        '¿Interesado en Información de Inclusión Financiera?',
        //Informacion organizacional
        '¿Vinculado a algúna Organización?',
        'Tipo de Organización',
        'Nombre de la organización',
        'Es una organización de Mujeres?',
        //Validacion interna
        '¿Validado Por Registraduría?',
        '¿Validado Por Procuraduría?',
        '¿Validado Por Policía?',
        'Mediadas correctivas',
        '¿Validación Por Contraloría',
        '% Documentación',
        //visitas
        'Número de visitas técnicas',
        //Ecas

        'Meta sesión ECAs por participante',
        ...ecaKeys,
        'Total sesión de ECAs',
        '% Participación en ECAs'

      ];


    // Configuración del ancho de las columnas
    worksheet.columns = datos.map(() => ({ width: 20 }));
    // Agregar fila de encabezado
    worksheet.addRow(datos);



    // Mapear y seleccionar todos los campos de participantes
    const dataToExport = data.map((part, index) => [

      //Ubicación del proyecto
      index + 1,
      part.codigo,
      part.proyecto,
      part.nombre_subregion_pdet,
      part.departamento,
      part.municipio,
      part.tipo_zona_influencia,
      part.nombre_zona,
      part.Implemetador,
      //Datos basicos
      part.nombre_participante,
      part.tipo_identificacion,
      part.numero_identificacion,
      part.sexo,
      formatDate(part.fecha_nacimiento),
      part.sabe_leer_escribir,
      part.ingresos_mensuales,
      part.linea_economica,
      part.nivel_escolaridad,
      //part.Implementador,
      //Estado del participante
      part.estado_nombre,
      part.tipo_novedad_nombre,
      part.remplazo_oid ? 'Sí' : 'No',
      part.detalle_reemplazo || 'N/A',
      part.novedad_soporte,
      //Poblacion
      part.Campesino,
      part.Comunidad_Indigena,
      part.Comunidad_NARP,
      part.Comunidad_ROM,
      part.Victima,
      part.Discapacidad,
      part.LGBT_plus,
      part.Mujer_Rural,
      part.Joven_Rural,
      part.Adulto_Mayor,
      part.Reincorporado,
      part.Otro,

      //Informacion familiar
      part.cabeza_familia,
      part.num_personas_cargo,
      part.total_nucleo_familiar,
      part.estado_civil,
      part.nombre_conyuge,
      part.tipo_identificacion_conyuge,
      part.identificacion_conyuge,
      part.numero_contacto_conyuge,


      //Informacion del proyecto vinculado
      part.codigo_shape,
      part.nombre_predio,
      part.relacion_tenencia_predio,
      part.latitud,
      part.longitud,
      part.num_hectarias_proyecto,
      part.linea_productiva_1,
      part.variedad_establecida,
      part.linea_productiva_segundaria,
      part.num_hectareas,
      part.produccion_anual,
      part.distancia_cabecera_municipal,
      part.tiempo_cabecera_municipal,
      part.medio_transporte,
      part.vive_mismo_lugar,
      part.lugar_vivienda,

      //Datos del beneficiario
      part.direccion_correspondencia,
      part.numero_telefonico_1,
      part.numero_telefonico_2,
      part.correo_electronico,

      //Conectividad
      part.telefonica,
      part.internet,
      part.establemcimiento_bancario,
      part.cuenta_con_productos_financieros,
      part.cuenta_de_ahorro,
      part.tarjeta_de_credito,
      part.otros_creditos,
      part.tipo_entidad,

      //Informacion bancaria
      part.recibio_capacitacion_educacion_financiera,
      part.interesado_informacion_inclusion_financiera,

      //Informacion organizacional
      part.vinculado_alguna_organizacion,
      part.tipo_organizacion,
      part.organizacion,
      part.org_mujeres,

      //Validacion interna
      part.validado_registraduria,
      part.validado_procuraduria,
      part.validado_policia,
      part.RNMC,
      part.validado_contraloria,
      part.progress,

      //visitas
      part.total_archivos_visitas,

      //Ecas
      part.ecas_info?.total_ecas_participa ?? '',
      ...ecaKeys.map(k => part.ecas_info?.[k] ?? ''),
      part.ecas_info?.total_ecas ?? '',
      part.ecas_info?.porcentaje_participacion != null ? `${part.ecas_info.porcentaje_participacion}%` : '0%'
    ]);


    // Agregar los datos a la hoja
    worksheet.addRows(dataToExport);

    // Aplicar colores a todos los rangos
    applyBackgroundColor('A', 'I', '3', 'A9D6E5');
    applyBackgroundColor('J', 'R', '3', 'B7E4C7');
    applyBackgroundColor('S', 'W', '3', 'F7D6E0');   // antes S-U (Estado del participante ahora termina en W)
    applyBackgroundColor('X', 'AJ', '3', 'CCCCCC');   // antes V-AH
    applyBackgroundColor('AK', 'AR', '3', 'D0EBFF');  // antes AI-AP
    applyBackgroundColor('AS', 'BH', '3', 'CFFFE5');  // antes AQ-BF
    applyBackgroundColor('BI', 'BK', '3', 'E6CCF0');  // antes BG-BI
    applyBackgroundColor('BL', 'BM', '3', 'EED6C4');  // antes BJ-BK
    applyBackgroundColor('BN', 'BU', '3', 'C7CEEA');  // antes BL-BS
    applyBackgroundColor('BV', 'BY', '3', 'E1F0C4');  // antes BT-BW
    applyBackgroundColor('BZ', 'CE', '3', 'D6E6F2');  // antes BX-CD
    applyBackgroundColor('CF', 'CF', '3', 'A9D6E5');  // antes CD-CD


    //Ecas
    // Aplicar color a la sección de ECAs
    const totalColsBeforeEcas = datos.length - (ecaKeys.length + 3); // 3 campos fijos al final
    const startEcaCol = numberToColumn(totalColsBeforeEcas + 1);
    const endEcaCol = numberToColumn(datos.length);

    const titleCellRef = `${startEcaCol}2`;
    const titleRange = `${startEcaCol}2:${endEcaCol}2`;
    worksheet.mergeCells(titleRange);
    worksheet.getCell(titleCellRef).value = 'PARTICIPACIÓN EN ECAS';
    worksheet.getCell(titleCellRef).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFD6E0' }
    };
    worksheet.getCell(titleCellRef).font = {
      size: 14,
      bold: true,
      color: { argb: '000000' }
    };
    worksheet.getCell(titleCellRef).alignment = {
      vertical: 'middle',
      horizontal: 'center',
      wrapText: true
    };

    // Colorea también la fila de los subcampos de ECAs (fila 3)
    applyBackgroundColor(startEcaCol, endEcaCol, '3', 'FFD6E0');


    // Ajustar el formato específico para la fila 3
    var row3 = worksheet.getRow(3);
    row3.eachCell({ includeEmpty: true }, function (cell, colNumber) {
      cell.font = { size: 12, bold: true }; // Aplicar negrita y tamaño de fuente 16
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
    });

    // Ajustar el formato de todas las celdas
    worksheet.eachRow(
      { includeEmpty: true },
      function (row, rowNumber) {
        row.eachCell(
          { includeEmpty: true },
          function (cell, colNumber) {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            }; // Bordes
          }
        );
      }
    );
    // Guardar el archivo Excel
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    });
  };

  return (
    <Button
      type="danger"
      className="btn btn-primary me-2"
      size="large"
      onClick={handleExport}
      icon={<DownloadOutlined />}
    >
      Excel
    </Button>
  );
};

export default ExportToExcelParticipantes;
